import Vue from 'vue'
import App from './App.vue'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueExcelXlsx from "vue-excel-xlsx";
// import vuetify from './plugins/vuetify';
import store from './store/store'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'
// import VueNumberInput from '@chenfengyuan/vue-number-input';

import localization from './javascript/localization'
// import { ValidationProvider } from 'vee-validate/dist/vee-validate.full.esm';
// import { ValidationObserver } from 'vee-validate';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import './javascript/vee-validate';

// Vue.component('ValidationProvider', ValidationProvider);
// Vue.component('ValidationObserver', ValidationObserver);

import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'

// Vue.use(VueNumberInput);
Vue.use( CKEditor );
Vue.use(VueExcelXlsx);
Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAWvNLVu-AM_O_3gVBqlTCfiwfyvIttNNk',
    libraries: 'places', // This is required if you use the Autocomplete plugin
  },
  installComponents: false,
})

Vue.component('google-map', VueGoogleMaps.Map);
Vue.component('google-map-marker', VueGoogleMaps.Marker);
Vue.component('google-map-info-window', VueGoogleMaps.InfoWindow);
Vue.component('google-map-cluster', GmapCluster);

const i18n = localization.setLanguageSettings(Vue)
store.state.router = router
store.state.i18n = i18n
// store.state.validator = ValidationObserver

new Vue({
  i18n,
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
